const I18N_DEFAULT_LANGUAGE = "es";
const LOCIZE_API_KEY = process.env.LOCIZE_API_KEY;
const LOCIZE_PROJECT_ID = "cec3c358-6406-4a73-ad17-06ef70d79f57";
module.exports = Object.freeze({
  I18N_DEFAULT_LANGUAGE,
  LOCIZE_API_KEY,
  LOCIZE_PROJECT_ID
});
